<template>
  <span class="d-none d-lg-block d-xl-block mb-2 ont-size-14px">
    Selezione del posto per
    <span class="text-primary semibold">{{ passengerName }}</span>
    <span v-if="isHoldingInfant">
      con <span class="text-primary semibold">neonato</span>
    </span>
  </span>
</template>

<script>
import { formatPassengerName } from '@liveflight/utilities/mixins'

export default {
  name: 'PassengerContextDisplay',
  props: {
    passenger: Object,
    isHoldingInfant: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    passengerName() {
      return formatPassengerName(this.passenger)
    },
  },
}
</script>
